import { api } from '@/lib/api/client';

export type IntegrationProvider = 'webhook' | 'hubspot' | 'mailchimp';

export interface Integration {
  id: number;
  provider: IntegrationProvider;
  name: string;
  enabled: boolean;
  config: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;
}

export interface IntegrationStats {
  // Job state counts. State is a free-form string at the entity level, but in
  // practice we emit: PENDING, SENT, FAILED, SKIPPED. Unknown keys render fine.
  [state: string]: number;
}

export const integrationsApi = {
  list: () => api.get<Integration[]>('/integrations'),

  create: (input: {
    provider: IntegrationProvider;
    name?: string;
    enabled?: boolean;
    config?: Record<string, unknown>;
  }) => api.post<Integration>('/integrations', input),

  update: (
    id: number,
    input: {
      provider: IntegrationProvider;
      name?: string;
      enabled?: boolean;
      config?: Record<string, unknown>;
    },
  ) => api.put<Integration>(`/integrations/${id}`, input),

  remove: (id: number) => api.delete<{ ok: true }>(`/integrations/${id}`),

  stats: () => api.get<IntegrationStats>('/integrations/stats'),

  // Manual dispatch — useful while we don't have a cron worker. v1: returns
  // sent/failed totals for the batch.
  dispatchTick: () =>
    api.post<{ sent: number; failed: number }>('/integrations/dispatch-tick', {}),
};
